import InlineTable from '../primitives/InlineTable';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import {
    buildColumns,
    buildRows,
    parentName,
    pinnedTitleParts,
} from '../lib/tableHelpers';
import type { TableModel, VisualProps, VisualWidget } from '../types';

const NAME_KEY = 'brand_name';
const TYPE_LABEL = 'Brand';

/** `brand_list_inline_table` — an anchor-less list of specific brands (their
 * category-less pop-index rows). */
function buildBrandListTableModel({
    input,
    output,
    title: customTitle,
}: VisualProps): TableModel {
    const columns = buildColumns(input?.order_by);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            custom: customTitle || undefined,
            parent: parentName(output),
            noun: 'brands',
            ...pinnedTitleParts(output, NAME_KEY),
            lifeCycle: input?.life_cycle,
        },
        link: output?.result?.dashboard_url,
        nameColumnHeader: 'Brand',
        columns,
        rows: buildRows(output, columns, NAME_KEY),
    };
}

const BrandListInlineTable = ({ Frame, dense, ...props }: VisualProps) => (
    <InlineTable
        {...buildBrandListTableModel(props)}
        Frame={Frame}
        dense={dense}
    />
);

const widget: VisualWidget = {
    match: (input) =>
        (input?.data_source ?? 'pop_index') === 'pop_index' &&
        input?.entity_relationship === 'brands' &&
        !input?.entity_type &&
        input?.entity_index == null &&
        !input?.entity_id &&
        // Chart-view lists render their charts (disjoint REGISTRY matches).
        !input?.aggregate &&
        !input?.trend_lines,
    Component: BrandListInlineTable,
};

export default widget;
